import { AxiosResponse } from "axios";


import courseApiRequest from "../../../utils/apiUtils/courseApiRequest";
import HighspotFileIntegrationDTO from "../../../models/HighspotFileIntegrationDTO";
import RequestFileSearchDTO from "../../../models/RequestFileSearchDTO";





/*export function doSubscription(request: SubscriptionRequestDTO) {
    const url = "/training/emails/subscribe";
    return apiRequest.post(url, request).then((response: AxiosResponse) => {
        return response;
    });

}*/


export function getAllHighspotFIles() {
    const url = "/highspot-zift/get/all-files";
    return courseApiRequest.get(url).then((response: AxiosResponse) => {
        return response;
    });

}

export function getAllHighspotFIlesByCriteria(search: RequestFileSearchDTO) {
    const url = "/highspot-zift/get/files-by-fields";
    return courseApiRequest.post(url, search).then((response: AxiosResponse) => {
        return response;
    });

}

export function updateHighspotFilesOnDB(filesToUpdate: Array<HighspotFileIntegrationDTO>) {
    const url = "/highspot-zift/update/files";
    return courseApiRequest.post(url, filesToUpdate).then((response: AxiosResponse) => {
        return response;
    });

}



